import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ActionCable from 'actioncable';

export default class MessagesDialog extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className="u-fixed u-inset-0 u-z-75">
        <div className="u-overlay u-cursor-pointer" onClick={this.props.onClose} />

        <div className="u-relative u-mx-auto u-flex u-items-center u-justify-center u-h-full u-pointer-events-none">
          <div className="u-m-6 u-p-6 u-max-w-3xl u-shadow u-bg-white u-rounded-lg u-flex-1 u-pointer-events-auto">
            TODO
          </div>
        </div>
      </div>
    );
  }
}
